import React, { useRef, useState } from 'react';
import { useTranslation } from '../contexts/LocaleContext';
import ToastContainer from 'react-bootstrap/esm/ToastContainer';
import { Toast } from 'react-bootstrap';
import { createPortal } from 'react-dom';

type FileDropzoneProps = {
  value: File | File[] | null;
  onChange: (value: File | File[] | null) => void;
  multiple?: boolean;
  accept?: string;
};
const MAX_FILE_SIZE = 10 * 1024 * 1024;
const FileDropzone: React.FC<FileDropzoneProps> = ({
  value,
  onChange,
  multiple = false,
  accept = 'image/*,video/*',
}) => {
  const t = useTranslation();
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [isDragging, setIsDragging] = useState(false);

  const files: File[] = value == null ? [] : Array.isArray(value) ? value : [value];
  const hasFiles = files.length > 0;
  const [showToast, setShowToast] = useState(false);


  // const handleSelect = (selected: FileList | null) => {
  //   if (!selected || selected.length === 0) {
  //     onChange(multiple ? [] : null);
  //     return;
  //   }
  //   const arr = Array.from(selected);
  //   if (multiple) {
  //     onChange(arr);
  //   } else {
  //     onChange(arr[0]);
  //   }
  // };
const showErrorToast = () => {
  setShowToast(true);

  setTimeout(() => {
    setShowToast(false);
  }, 3000);
};
  const handleSelect = (selected: FileList | null) => {
  if (!selected || selected.length === 0) {
    onChange(multiple ? [] : null);
    return;
  }

  const arr = Array.from(selected);

  const validFiles = arr.filter(file => file.size <= MAX_FILE_SIZE);
  const invalidFiles = arr.filter(file => file.size > MAX_FILE_SIZE);

  if (invalidFiles.length > 0) {
    showErrorToast();
  }

  if (validFiles.length === 0) {
    onChange(multiple ? [] : null);
    return;
  }

  if (multiple) {
    onChange(validFiles);
  } else {
    onChange(validFiles[0]);
  }
};
  return (
    <>
      <input
        ref={fileInputRef}
        type="file"
        accept={accept}
        multiple={multiple}
        className="d-none"
        onChange={(e) => handleSelect(e.target.files)}
      />
      <div
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            fileInputRef.current?.click();
          }
        }}
        onClick={() => fileInputRef.current?.click()}
        onDragOver={(e) => {
          e.preventDefault();
          e.stopPropagation();
          setIsDragging(true);
        }}
        onDragLeave={(e) => {
          e.preventDefault();
          e.stopPropagation();
          setIsDragging(false);
        }}
        onDrop={(e) => {
          e.preventDefault();
          e.stopPropagation();
          setIsDragging(false);
          handleSelect(e.dataTransfer?.files ?? null);
        }}
        style={{
          border: `2px dashed ${isDragging ? 'var(--bs-primary)' : '#dee2e6'}`,
          borderRadius: 8,
          padding: '1.5rem',
          textAlign: 'center',
          cursor: 'pointer',
          backgroundColor: isDragging ? 'rgba(13, 110, 253, 0.08)' : 'transparent',
          transition: 'border-color 0.15s, background-color 0.15s',
        }}
      >
        {hasFiles ? (
          <span className="text-muted">
            {multiple && files.length > 1
              ? `${files.length} ${t('formField.files') || 'файлов'}`
              : files[0].name}
          </span>
        ) : (
          <span className="text-muted text-break">
            {t('formField.dragndrop') || 'Перетащите файл сюда или нажмите для выбора'}
          </span>
        )}
      </div>
        {createPortal(
  <ToastContainer
   position="top-end"
    className="p-3"
    style={{ 
      zIndex: 9999,  
      top: '2rem',
      right: '2rem'
    }}
  >
    <Toast
      bg="danger"
      onClose={() => setShowToast(false)}
      show={showToast}
      delay={3000}
      autohide
    >
      <Toast.Body className="text-white text-center">
        <span>{t('formField.tooBigFile') || 'Файл слишком большой.'}</span>
        <br />
        <span>{t('formField.maxFileSize') || 'Максимальный размер 10 MB.'}</span>
      </Toast.Body>
    </Toast>
  </ToastContainer>,
  document.body
)}
    </>
  );
};

export default FileDropzone;
